// extracted by mini-css-extract-plugin
var _1 = "TemplateCard_brand__cfe75";
var _2 = "TemplateCard_counter__16fe0";
var _3 = "TemplateCard_icon__c36ff";
var _4 = "TemplateCard_iconWrapper__d0ddf";
var _5 = "TemplateCard_info__0541b";
var _6 = "TemplateCard_name__acebf";
var _7 = "TemplateCard_textWrap__cf707";
export { _1 as "brand", _2 as "counter", _3 as "icon", _4 as "iconWrapper", _5 as "info", _6 as "name", _7 as "textWrap" }
